import { isLocalDev } from 'utils/environment';

import { consoleHandler, datadogHandler } from './handlers';
import { errorCategoryMiddleware, uuidScrubberMiddleware } from './middleware';

export const DEFAULT_HANDLERS = isLocalDev ? [datadogHandler, consoleHandler] : [datadogHandler];
export const DEFAULT_MIDDLEWARES = [uuidScrubberMiddleware, errorCategoryMiddleware];
